/* eslint-disable jsx-a11y/alt-text */
import { Image, Text, View } from '@react-pdf/renderer'
import { format } from 'date-fns'

import { Translator } from '@/types'

import { rotorStyles } from '../styles'

type RotorFooterProps = {
  t: Translator
  project?: string
  template?: string
  date?: string
  firstPageNumber?: number
  footerLabelOverride?: string
}

export const RotorFooter = ({
  t,
  project,
  template,
  date,
  firstPageNumber = 1,
  footerLabelOverride,
}: RotorFooterProps) => {
  const ref = project?.slice(0, 10)
  const name = project?.split('-').pop()
  const versionDate = date ? new Date(date) : new Date()
  const dateLabel = format(versionDate, 'dd/MM/yyyy')

  return (
    <View style={rotorStyles.footer}>
      <View
        style={{
          flexDirection: 'row',
          gap: 2,
          alignItems: 'center',
        }}
      >
        <Image src="/img/rotor_logo_vector.jpg" style={rotorStyles.logo} />
        <Text style={rotorStyles.footerReference}>{ref}</Text>
        {!!project && !footerLabelOverride && (
          <Text style={rotorStyles.footerText}>{`- ${name}`}</Text>
        )}
        <Text style={rotorStyles.footerText}>
          {footerLabelOverride || t('Preview.RotorFooterTitle', { dateLabel })}
        </Text>
      </View>
      {template !== 'references' ? (
        <Text
          style={rotorStyles.footerText}
          render={({ pageNumber }) => {
            const number = firstPageNumber + pageNumber - 1
            return template === 'rotor'
              ? `${number}`
              : t('Preview.RotorFooterNumber', { pageNumber: number })
          }}
        />
      ) : null}
    </View>
  )
}
